import feather from 'feather-icons'

const NAV_ITEMS = {
  items: [
    {
      title: 'User Management',
      id: 'user-management-nav',
      routerName: 'users',
      icon: feather.icons.user.toSvg(),
    },
    {
      title: 'Device Management',
      id: 'device-management-nav',
      routerName: 'devices',
      icon: feather.icons['hard-drive'].toSvg(),
    },
    {
      title: 'Group Management',
      id: 'group-management-nav',
      routerName: 'groups',
      icon: feather.icons.users.toSvg(),
    },
    {
      title: 'Physical Access Log',
      id: 'access-logs-nav',
      routerName: 'accessLogs',
      icon: feather.icons['file-text'].toSvg(),
    },
    {
      title: 'Configuration',
      id: 'configuration-nav',
      routerName: 'configuration',
      icon: feather.icons.settings.toSvg(),
      authorizationResource: 'configuration',
    },
  ],
  icons: {
    moreEllipse: feather.icons['more-vertical'].toSvg(),
    logOut: feather.icons['log-out'].toSvg(),
    externalLink: feather.icons['external-link'].toSvg(),
    feedback: feather.icons['message-circle'].toSvg(),
    alert: feather.icons.bell.toSvg(),
    help: feather.icons['help-circle'].toSvg(),
  },
}

const navigationMixin = {
  computed: {
    navigation() {
      return NAV_ITEMS
    },
  },
}

export default navigationMixin
